interface BlockedTelehealthCity {
  city: string;
  state: string;
}

export const BLOCKED_TELEHEALTH_CITIES: BlockedTelehealthCity[] = [
  { city: 'Divinópolis', state: 'MG' },
];

function normalizeCity(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase();
}

export function isBlockedTelehealthCity(city?: string, state?: string): boolean {
  if (!city || !state) {
    return false;
  }

  const normalizedCity = normalizeCity(city);
  const normalizedState = state.trim().toUpperCase();

  return BLOCKED_TELEHEALTH_CITIES.some(
    (blocked) =>
      normalizeCity(blocked.city) === normalizedCity && blocked.state.trim().toUpperCase() === normalizedState,
  );
}
